var React = require('react');

function ChainLink (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.789 9.012a.911.911 0 0 0-1.278 0 .877.877 0 0 0 0 1.245l5.464 5.375a.75.75 0 0 0 1.052 0l5.465-5.375a.877.877 0 0 0 0-1.245.911.911 0 0 0-1.278 0L12.5 13.647 7.79 9.012z","transform":"rotate(180 12.501 12.299)","fill":"currentColor"}));
}

ChainLink.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = ChainLink;

ChainLink.default = ChainLink;
